import { render, staticRenderFns } from "./hotel-list.vue?vue&type=template&id=596d75a9&scoped=true"
import script from "./hotel-list.vue?vue&type=script&lang=js"
export * from "./hotel-list.vue?vue&type=script&lang=js"
import style0 from "./hotel-list.vue?vue&type=style&index=0&id=596d75a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d75a9",
  null
  
)

export default component.exports